import BaseStore from '@src/utils/store/base-store';
import { observable } from 'mobx';

class NewMechaScreenStore extends BaseStore {
  @observable isActive = false;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  use() {
    super.use();
  }
}

export default NewMechaScreenStore;
